import React from 'react';
import PropTypes from 'prop-types';
import {UserAgentUtils} from "utils/useragent";

const isMobile = UserAgentUtils.isMobile();

TopTableHeaderActionContainer.propTypes = {
    children: PropTypes.node,
};

function TopTableHeaderActionContainer(props) {
    return (
        <div style={{
            display: "flex",
            alignItems: "center",
            gap: 1,
            flexWrap: "wrap",
            ...isMobile && {
                width: '100%'
            }
        }}>
            {props.children}
        </div>
    );
}

export default TopTableHeaderActionContainer;
